import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// PrimeNG Modules
import { SidebarModule } from 'primeng/sidebar';
import { PanelMenuModule } from 'primeng/panelmenu';

// Common Components
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LandingHeaderComponent } from './landing-header/landing-header.component';
import { LandingFooterComponent } from './landing-footer/landing-footer.component';

// UI Component Modules
import { ButtonComponentModule } from './ui/button/button-component.module';
import { TypographyComponentModule } from './ui/typography/typography.module';
import { ModalComponentModule } from './ui/modal/modal-component.module';
import { MenuComponentModule } from './ui/menu/menu.module';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    LandingHeaderComponent,
    LandingFooterComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SidebarModule,
    PanelMenuModule,
    ButtonComponentModule,
    TypographyComponentModule,
    ModalComponentModule,
    MenuComponentModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    LandingHeaderComponent,
    LandingFooterComponent
  ]
})
export class CommonComponentsModule { }
